<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showRequestTraining"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full h-5/6 overflow-y-auto"
        >
          <img
            class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md fixed right-2 top-2 z-50"
            src="@/assets/icons/cross-white.png"
            alt="icon"
            @click="close()"
          />

          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-left border-b-1.5 p-3">
            <p class="text-base">Request Training</p>
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div class="grid md:grid-cols-3 grid-cols-1 p-4 gap-3">
            <div class="text-sm">
              <label class="block pb-1">Training Name</label>
              <input
                required
                v-model="info.Name"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Start Date</label>
              <input
                v-model="info.StartDate"
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="End Date"
                required
              />
              <!--  new Date(minimuSelectableDate).toISOString().split('T')[0] -->
            </div>

            <div class="text-sm">
              <label class="block pb-1">End Date</label>
              <input
                v-model="info.EndDate"
                :disabled="!info.StartDate"
                type="date"
                :min="new Date(info.StartDate).toISOString().split('T')[0]"
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="End Date"
                required
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Urgency</label>
              <div
                class="flex flex-wrap justify-between bg-gray-200 rounded-md px-2 py-2"
                style="display: flex; align-items: center"
              >
                <label
                  class="b-contain"
                  style="display: flex; align-items: center"
                >
                  <span>Mild</span>
                  <input
                    :checked="info.Urgency === 'Mild'"
                    type="radio"
                    name="urgency"
                    value="Mild"
                    v-model="info.Urgency"
                  />
                  <div class="b-input"></div>
                </label>
                <label
                  class="b-contain"
                  style="display: flex; align-items: center"
                >
                  <span>Urgent</span>
                  <input
                    :checked="info.Urgency === 'Urgent'"
                    type="radio"
                    name="urgency"
                    value="Urgent"
                    v-model="info.Urgency"
                  />
                  <div class="b-input"></div>
                </label>

                <label
                  class="b-contain"
                  style="display: flex; align-items: center"
                >
                  <span>Trivial</span>
                  <input
                    :checked="info.Urgency === 'Trivial'"
                    type="radio"
                    name="urgency"
                    value="Trivial"
                    v-model="info.Urgency"
                  />
                  <div class="b-input"></div>
                </label>
              </div>
            </div>

            <!-- <div class="text-sm">
              <label class="block pb-1">Training Source</label>
              <input
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full disabled border-0.5"
                v-model="info.Source"
                required
              />
            </div> -->
            <div class="text-sm">
              <label class="block pb-1">Training Type</label>
              <div
                class="flex flex-wrap justify-between bg-gray-200 rounded-md px-2 py-2"
              >
                <label
                  class="b-contain"
                  style="display: flex; align-items: center"
                >
                  <span>Online</span>
                  <input
                    type="radio"
                    name="trainingType"
                    v-model="info.TrainingType"
                    value="Online"
                  />
                  <div class="b-input"></div>
                </label>
                <label
                  class="b-contain"
                  style="display: flex; align-items: center"
                >
                  <span>Classroom</span>
                  <input
                    type="radio"
                    name="trainingType"
                    v-model="info.TrainingType"
                    value="Classroom"
                  />
                  <div class="b-input"></div>
                </label>
              </div>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Training Source</label>
              <input
                v-if="info.TrainingType === 'Online'"
                type="url"
                placeholder="Enter URL"
                class="p-2 bg-gray-200 rounded-full w-full"
                v-model="info.Source"
                required
              />
              <input
                v-else
                type="text"
                placeholder="Enter source "
                class="p-2 bg-gray-200 rounded-full w-full"
                v-model="info.Source"
                required
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Training Cost</label>
              <input
                class="p-2 bg-gray-200 rounded-full w-full disabled border-0.5"
                v-model="info.Cost"
                required
              />
            </div>
          </div>
          <div class="text-sm px-3">
            <label class="block pb-1">Approver</label>

            <el-select
              filterable
              class="bg-gray-200 rounded-full w-full border-none"
              v-model="info.Approver"
              placeholder="Select a manager"
            >
              <el-option
                v-for="manager in approvers"
                :key="manager.ManagerId"
                :label="decryptDataLocal(manager.ManagerName, decryptionKey)"
                :value="manager.ManagerId"
                >{{ decryptDataLocal(manager.ManagerName, decryptionKey) }}
              </el-option>
            </el-select>
          </div>

          <div class="p-4">
            <label>Description </label>
            <textarea
              v-model="info.Description"
              class="p-1 bg-gray-200 rounded-xl w-full"
              cols="5"
              rows="8"
            ></textarea>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
import decryptData from "@/utils/decrypt";

export default {
  name: "RequestTraining",
  props: [
    "showRequestTraining",
    "isSubmitted",
    "closeOnSuccess",
    "leaveRequestCallback",
    "approvers",
    "refresh",
  ],
  components: {
    Loader,
  },
  data() {
    return {
      create_error: null,
      loading: false,
      decryptDataLocal: "",
      decryptionKey: "",
      minimuSelectableDate: new Date(),

      info: {
        Name: null,
        StartDate: null,
        EndDate: null,
        Urgency: "",
        Source: "",
        Cost: "",
        Description: "",
        Approver: "",
        TrainingType: "Online",
      },
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.decryptionKey = this.$decryptionKey;
    this.decryptDataLocal = decryptData;
    // this.getApprovers();
  },
  watch: {},
  methods: {
    close() {
      this.$emit("close");
    },

    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .post(
          `${this.getOrganization}/training/${this.$ApiVersion}/request`,
          this.info,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.LeaveTypes = response.data.Data;
              this.success = response.data.StatusMessage;
              this.$notify({
                title: "Success",
                message: response.data.StatusMessage,
                type: "success",
              });

              this.info = {
                Name: null,
                StartDate: null,
                EndDate: null,
                Urgency: "",
                Source: "",
                Cost: "",
                Description: "",
                Approver: "",
              };

              this.loading = false;
              this.selectedLeaveType = "";
              this.close();
              this.refresh();
            } else {
              this.create_error = response.data.StatusMessage;
              this.$notify.error({
                title: "Success",
                message: response.data.StatusMessage,
              });
              this.loading = false;
              setTimeout(() => {
                this.create_error = null;
              }, 1500);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;

            this.$notify.error({
              title: "Success",
              message: error.message,
            });
            setTimeout(() => {
              this.create_error = null;
            }, 1500);
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
